import type { SVGProps } from "react";
// generated from Cancel.svg — do not edit manually
// prettier-ignore
export default function Cancel(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 19.0711 4.929 C 22.9763 8.834 22.9763 15.166 19.0711 19.071 C 15.1658 22.976 8.8342 22.976 4.9289 19.071 M 19.0711 4.929 C 15.1658 1.024 8.8342 1.024 4.9289 4.929 C 1.0237 8.834 1.0237 15.166 4.9289 19.071 M 19.0711 4.929 L 4.9289 19.071" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
